import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'biz-proxy-object',
  templateUrl: './proxy-object.component.html',
  styleUrls: ['./proxy-object.component.scss']
})
export class ProxyObjectComponent implements OnInit {

  @Input() proxyObj: IProxyObject;
  passwordType = 'password';
  passwordIcon = 'icn-eye';
  allowedIps = '';

  constructor() {
  }

  ngOnInit(): void {
    if (this.proxyObj && this.proxyObj.allowedIps) {
      this.allowedIps = this.proxyObj.allowedIps.join(';');
    }
  }

  onTextBoxChange(event) {
    this.proxyObj.allowedIps = event.split(';');
  }
  showHidePassword() {
    if (this.passwordType === 'password') {
      this.passwordType = 'text';
      this.passwordIcon = 'icn-eye-off';
    } else {
      this.passwordType = 'password';
      this.passwordIcon = 'icn-eye';
    }
  }

}
